module.exports = __webpack_public_path__ + "static/media/arrow-left.acbacb3a.svg";